import * as React from 'react';
const SvgArrowClockwise = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M20.93 4.27a.5.5 0 0 0-.22-.22C20.6 4 20.46 4 20.18 4h-.669a.55.55 0 0 0-.25.05c-.089.05-.169.12-.219.22-.05.11-.05.25-.05.53v1.58C17.344 4.33 14.837 3 12 3c-4.974 0-9 4.03-9 9s4.026 9 8.99 9c2.198 0 4.215-.79 5.764-2.1.19-.16.29-.25.34-.36.04-.1.04-.22.01-.33-.04-.12-.13-.22-.33-.42l-.28-.28c-.2-.2-.3-.3-.4-.33a.48.48 0 0 0-.29-.02c-.11.03-.23.12-.469.32A6.97 6.97 0 0 1 11.99 19a6.99 6.99 0 0 1-6.992-7c0-3.87 3.126-7 6.992-7a6.99 6.99 0 0 1 5.544 2.74c.09.11.15.19.21.26h-1.948c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .19 0 .31.02.41 0 .05.02.08.04.12.05.09.12.17.22.22.11.05.25.05.53.05h2.397c.999 0 2.038 0 2.248-.11.09-.05.17-.1.24-.17.08-.08.15-.17.2-.27C21 9.24 21 8.2 21 7.2V4.8c0-.28 0-.42-.05-.53z"
    />
  </svg>
);
export default SvgArrowClockwise;
